import React from 'react';
import UpdateNotification from './UpdateNotification';
import useAppUpdates from '../../hooks/useAppUpdates';

/**
 * App Update Provider
 * Provides update notification functionality to the entire app
 */
const AppUpdateProvider = ({ children }) => {
  const {
    isVisible,
    autoRefresh,
    countdown,
    handleRefresh,
    handleDismiss,
    handleLater,
    // checkForUpdates
  } = useAppUpdates();

  return (
    <>
      {children}
      <UpdateNotification
        isVisible={isVisible}
        onRefresh={handleRefresh}
        onDismiss={handleDismiss}
        onLater={handleLater}
        autoRefresh={autoRefresh}
        countdown={countdown}
      />
      {/* Debug Test Update Check button removed */}
    </>
  );
};

export default AppUpdateProvider;
